export default __webpack_public_path__ + "static/media/bt.ef7444a3.svg";